const Contact = () => {
      return (
        <div id='embed'>
             <iframe id="JotFormIFrame-230766926766067" title="Contact Form" allow="geolocation; microphone; camera" src="https://form.jotform.com/230766926766067" frameBorder="0" style={{minWidth:'100%',maxWidth:'100%',height:'100vh',border:'none'}} scrolling="no" > </iframe> 
        </div>
      )
};
export default Contact;
